import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { blogPosts } from '../mock';
import { ArrowLeft } from 'lucide-react';

export default function BlogPost() {
  const { id } = useParams();
  const post = blogPosts.find((p) => String(p.id) === String(id)) || blogPosts[0];

  return (
    <>
      <Navbar />
      <section style={{ paddingTop: 160, paddingBottom: 60, background: 'var(--sm-ivory)' }}>
        <div className="container-x" style={{ maxWidth: 900 }}>
          <Link to="/" className="link-underline" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 12, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'var(--sm-navy)', textDecoration: 'none', marginBottom: 32 }}>
            <ArrowLeft size={14} /> Back to Journal
          </Link>
          <div style={{ fontSize: 11, letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--sm-gold)', marginBottom: 16 }}>{post.category} · {post.date}</div>
          <h1 className="serif" style={{ fontSize: 'clamp(36px, 5vw, 60px)', lineHeight: 1.08, letterSpacing: '-0.015em', margin: 0, color: 'var(--sm-navy)' }}>{post.title}</h1>
        </div>
      </section>

      <section style={{ paddingBottom: 96, background: 'var(--sm-ivory)' }}>
        <div className="container-x" style={{ maxWidth: 900 }}>
          <div style={{ overflow: 'hidden', aspectRatio: '16/9', marginBottom: 56 }}>
            <img src={post.image} alt={post.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
          <div style={{ fontSize: 18, lineHeight: 1.9, color: 'var(--sm-navy)', textAlign: 'justify' }}>
            <p>{post.excerpt}</p>
            <p>Across two decades of building a global distribution platform, one lesson recurs: the smallest, most consistent efforts often produce the most lasting impact. This principle shapes not only how we operate a supply chain, but also how we contribute to the communities we serve.</p>
            <p>Trust is earned in single conversations. Value is built in modest, repeatable choices. Whether we are moving product across borders, evaluating a property, or supporting a community initiative, the discipline is the same: show up consistently, keep commitments, and let the long-term compound.</p>
            <p>Thank you for reading. If this piece resonated, feel free to reach out through the contact page.</p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
